// ============================================================
// ConditionChip - one coloured chip in a conditions or exposures list
// ============================================================
// The label in the code's own colours and, unless locked, a ✕ that
// removes it. The ✕ is a pure verb: the actor curtain's glass projection
// hides it (data-ghost-hide).

import type { CSSProperties, ReactNode } from 'react';
import styles from '../styles/ConditionsSection.module.css';

interface ConditionChipProps {
  colours: { bg: string; border: string; text: string };
  /** The label, and the ✕'s accessible name. */
  label: string;
  /** Removes it; null for no ✕ (locked, or read-only). */
  onRemove: (() => void) | null;
  testId?: string;
  title?: string;
  /** Faded, for a read-only chip. */
  opacity?: number;
  children?: ReactNode;
}

export function ConditionChip({ colours, label, onRemove, testId, title, opacity, children }: ConditionChipProps) {
  const style: CSSProperties = { background: colours.bg, borderColor: colours.border, color: colours.text };
  if (opacity !== undefined) style.opacity = opacity;
  return (
    <span className={styles.cond} style={style} title={title} data-testid={testId}>
      {children ?? label}
      {onRemove && (
        <button className={styles.remove} aria-label={`Remove ${label}`} onClick={onRemove} data-ghost-hide="true">
          {'✕'}
        </button>
      )}
    </span>
  );
}
